import axios from 'axios'
import axiosCancel from 'axios-cancel'
import config from './config'
import NProgress from 'nprogress'
import defaultAppConfig from '@/config/index'

const isTestMode = false
var baseApiUrl = config.apiUrl
axios.defaults.baseURL = baseApiUrl
axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['X-App-Version'] = defaultAppConfig.appVersion

const defaultConfig = {
}

axiosCancel(axios, {
  debug: false
})

axios.interceptors.request.use(function (config) {
  if (typeof window === 'undefined') {
    return config
  }
  return config
})

// before a request is made start the nprogress
axios.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
axios.interceptors.response.use(response => {
  NProgress.done()
  return response
}, function (error) {
  NProgress.done()
  return Promise.reject(error)
})

export default { isTestMode, defaultConfig, baseApiUrl }
